import { z } from 'zod';
export const NEWSLETTER_ACTIVITY_KINDS = {
    Scheduled: 'newsletter.scheduled',
    Sent: 'newsletter.sent',
    Opened: 'newsletter.opened',
    Clicked: 'newsletter.clicked',
    SubscriberSubscribed: 'subscriber.subscribed',
    SubscriberUnsubscribed: 'subscriber.unsubscribed',
};
export const NEWSLETTER_ERROR_CODES = {
    Unauthenticated: 'NEWSLETTER_UNAUTHENTICATED',
    Forbidden: 'NEWSLETTER_FORBIDDEN',
    NotFound: 'NEWSLETTER_NOT_FOUND',
    Invalid: 'NEWSLETTER_INVALID',
    AlreadySent: 'NEWSLETTER_ALREADY_SENT',
    NotScheduled: 'NEWSLETTER_NOT_SCHEDULED',
    SubscriberNotFound: 'NEWSLETTER_SUBSCRIBER_NOT_FOUND',
};
export const NewsletterStatus = z.enum(['draft', 'scheduled', 'sent', 'cancelled']);
export const NewsletterSubscriberTier = z.enum(['free', 'paid']);
export const NewsletterCadence = z.enum(['instant', 'daily', 'weekly', 'monthly', 'paused']);
export const NewsletterSegmentCadence = z.enum(['instant', 'daily', 'weekly', 'monthly']);
export const NewsletterIssue = z.object({
    id: z.string().uuid(),
    newsletterId: z.string().uuid(),
    authorId: z.string().uuid().nullable(),
    audienceGroupId: z.string().uuid().nullable(),
    subject: z.string(),
    previewText: z.string(),
    body: z.array(z.unknown()),
    bodyText: z.string(),
    status: NewsletterStatus,
    segmentKey: z.string(),
    scheduledAt: z.string().datetime({ offset: true }).nullable(),
    sentAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const NewsletterSubscriber = z.object({
    id: z.string().uuid(),
    email: z.string(),
    userId: z.string().uuid().nullable(),
    tier: NewsletterSubscriberTier,
    cadence: NewsletterCadence,
    topics: z.array(z.string()),
    confirmedAt: z.string().datetime({ offset: true }).nullable(),
    unsubscribedAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const NewsletterSegmentQuery = z.object({
    tier: NewsletterSubscriberTier.optional(),
    cadence: NewsletterSegmentCadence.optional(),
    topicsAny: z.array(z.string()).optional(),
    topicsAll: z.array(z.string()).optional(),
    emails: z.array(z.string()).optional(),
});
export const NewsletterSegment = z.object({
    id: z.string().uuid(),
    newsletterId: z.string().uuid(),
    key: z.string(),
    name: z.string(),
    query: NewsletterSegmentQuery,
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=newsletter.js.map